import { FileTextIcon, ZapIcon, BotIcon, LaptopIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF & Mobile Access'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: LaptopIcon,
  label: 'Optimized for Laptop & Tablet'
}];
export const stats = [{
  value: '500+',
  label: 'Satisfied Attorneys'
}, {
  value: '6+4',
  label: 'Volumes + Bonuses'
}, {
  value: '99%',
  label: 'Success Rate'
}, {
  value: '4.9/5',
  label: '⭐ Global Rating'
}];
